/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateEvent
 */
export interface UpdateEvent {
    /**
     * If always, the integration will subscribe to update events by default.
     * @type {string}
     * @memberof UpdateEvent
     */
    enabled?: UpdateEventEnabledEnum;
    /**
     * If `all`, the integration will watch all fields for updates. If `selected`, the integration will watch only the fields that are selected by the user. If `inheritFieldsAndMapping` is true for Subscribe action, the integration will watch the selected fields from read action that are selected by the user.
     * @type {string}
     * @memberof UpdateEvent
     */
    watchFieldsAuto?: UpdateEventWatchFieldsAutoEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateEvent
     */
    requiredWatchFields?: Array<string>;
}


/**
 * @export
 */
export const UpdateEventEnabledEnum = {
    Always: 'always'
} as const;
export type UpdateEventEnabledEnum = typeof UpdateEventEnabledEnum[keyof typeof UpdateEventEnabledEnum];

/**
 * @export
 */
export const UpdateEventWatchFieldsAutoEnum = {
    All: 'all',
    Selected: 'selected'
} as const;
export type UpdateEventWatchFieldsAutoEnum = typeof UpdateEventWatchFieldsAutoEnum[keyof typeof UpdateEventWatchFieldsAutoEnum];


/**
 * Check if a given object implements the UpdateEvent interface.
 */
export function instanceOfUpdateEvent(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UpdateEventFromJSON(json: any): UpdateEvent {
    return UpdateEventFromJSONTyped(json, false);
}

export function UpdateEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateEvent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'watchFieldsAuto': !exists(json, 'watchFieldsAuto') ? undefined : json['watchFieldsAuto'],
        'requiredWatchFields': !exists(json, 'requiredWatchFields') ? undefined : json['requiredWatchFields'],
    };
}

export function UpdateEventToJSON(value?: UpdateEvent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enabled': value.enabled,
        'watchFieldsAuto': value.watchFieldsAuto,
        'requiredWatchFields': value.requiredWatchFields,
    };
}

